/**
 *
 * FormTab
 *
 */

import React from 'react';
import {
  Li,
  Tab,
  TitleWrapper,
  TabTitle,
} from './styledComponents';

const FormTab = ({ disabled, onClick, title, isActive, mementoPlan, disabledOthers }) => (
  <Li>
    <Tab onClick={!disabled && !disabledOthers && onClick}>
      <TitleWrapper isActive={isActive} >
        <TabTitle isActive={isActive} mementoPlan={mementoPlan}>{title}</TabTitle>
      </TitleWrapper>
    </Tab>
  </Li>
);

export default FormTab;



// WEBPACK FOOTER //
// ./src/components/FormTabs/FormTab.js